import { useSettingsModal } from '@/components/SettingsModal/store';
import { useUpgradeModal } from '@/features/billing/hooks/useUpgradeModal';
import { useOpenShareModal } from '@/features/permissions/components/ShareModal/store';
import { Modal, ModalOverlay } from '@/ui';
import { ComparePlansOrgVariation } from './variations/ComparePlansOrgVariation';

export const UpgradeModal = () => {
  const { isOpen, returnTo, heading, tiers, closeUpgradeModal } =
    useUpgradeModal();
  const { open: openSettingsModal } = useSettingsModal();
  const { openShareModal } = useOpenShareModal();

  const handleClose = () => {
    closeUpgradeModal();

    // Reopen the modal we came from, if any
    if (returnTo === 'settings') {
      openSettingsModal('subscription');
    } else if (returnTo === 'share') {
      openShareModal();
    }
  };

  return (
    <Modal
      isCentered
      isOpen={isOpen}
      returnFocusOnClose={false}
      scrollBehavior="inside"
      variant="primary"
      onClose={handleClose}
    >
      <ModalOverlay />
      <ComparePlansOrgVariation
        heading={heading}
        tiers={tiers}
        onClose={handleClose}
      />
    </Modal>
  );
};
